var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16C13.8 16 13.2083 15.7583 12.725 15.275C12.2417 14.7917 12 14.2 12 13.5C12 12.8 12.2417 12.2083 12.725 11.725C13.2083 11.2417 13.8 11 14.5 11C14.6333 11 14.7833 11.0127 14.95 11.038C15.1167 11.0633 15.3 11.1173 15.5 11.2V6H19V8H17V13.5C17 14.2 16.7583 14.7917 16.275 15.275C15.7917 15.7583 15.2 16 14.5 16ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM0 16V13.2C0 12.6167 0.146 12.0917 0.438 11.625C0.73 11.1583 1.11733 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.646 4.75 9.388C5.81667 9.13 6.9 9.00067 8 9C8.7 9 9.396 9.05433 10.088 9.163C10.78 9.27167 11.4757 9.434 12.175 9.65C11.075 10.3167 10.3917 11.271 10.125 12.513C9.85833 13.755 10.075 14.9173 10.775 16H0Z",
    fill: "#FF5C29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtist);
export default __webpack_public_path__ + "static/media/artist.05180c5ca8803a749025d0682af8db31.svg";
export { ForwardRef as ReactComponent };